import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'teachers',
    name: 'teachers',
    component: Index,
    title: 'teachers',
    redirect: { name: 'teacher-list' },
    children: [
      
      {
        path: 'list',
        name: 'teacher-list',
        component: List,
      },
      
    ],
  },
]
